import React, {useEffect, useState} from 'react';
import {useCurrentUser} from '../../../../contexts/UserContext';
import Logo from "./Logo";
import UserSettings from "./UserSettings";
import NavLinks from "./NavLinks";
import azureBLOBStorageService from "../../../../services/azureBLOBStorageService";
import {useViewerStore} from "../../../../store/store";

const Header = () => {
    const {user} = useCurrentUser();
    const [username, setUsername] = useState('User');
    const [isUserSettingsModalOpen, setIsUserSettingsModalOpen] = useState(false);

    useEffect(() => {
        setUsername(user?.user_name ?? 'User');
    }, [user]);

    useEffect(() => {


        //fetch profile photo and set it if available
        const fetchProfilePhoto = async () => {
            if(user?.user_Id) {
                const fileName = `${user?.user_Id}.png`
                const ifProfilePhotoExists = await azureBLOBStorageService.checkFileExist(fileName);
                if(ifProfilePhotoExists) {
                    const response = await azureBLOBStorageService.getFile(fileName);

                    if(response){
                        useViewerStore.setState({isProfilePhotoAvailable: true});
                        const bloburl = URL.createObjectURL(response);
                        useViewerStore.setState({userProfilePhoto: bloburl});
                    }
                }

            }

        }
        fetchProfilePhoto();
    }, [user]);

    return (
        <>
            <header className="header">
                <Logo/>
                <NavLinks username={username} setIsUserSettingsModalOpen={setIsUserSettingsModalOpen}/>
                <UserSettings setIsUserSettingsModalOpen={setIsUserSettingsModalOpen} isUserSettingsModalOpen={isUserSettingsModalOpen}/>
            </header>


        </>
    );
};

export default Header;